import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductPage from "./pages/ProductPage";
import Brands, { BrandPage } from "./pages/Brands";
import TradeIn from "./pages/TradeIn";
import TradeInFlow from "./pages/TradeInFlow";
import ClothCash from "./pages/ClothCash";
import Account from "./pages/Account";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";
import About from "./pages/About";
import GradeGuide from "./pages/GradeGuide";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import "@/App.css";

function Protected({ children, admin }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <div className="min-h-[60vh] flex items-center justify-center font-serif text-2xl text-muted-foreground">Jigel…</div>;
  if (!user) return <Navigate to={`/auth?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function SmoothScroll({ children }) {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  return children;
}

function App() {
  return (
    <SmoothScroll>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <div className="App min-h-screen flex flex-col">
              <Nav />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/men" element={<Shop gender="men" />} />
                  <Route path="/women" element={<Shop gender="women" />} />
                  <Route path="/kids" element={<Shop gender="kids" />} />
                  <Route path="/pre-loved" element={<Shop preloved />} />
                  <Route path="/new-arrivals" element={<Shop newArrivals />} />
                  <Route path="/sale" element={<Shop sale />} />
                  <Route path="/offers" element={<Shop sale />} />
                  <Route path="/sell" element={<TradeIn />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/grade-guide" element={<GradeGuide />} />
                  <Route path="/product/:id" element={<ProductPage />} />
                  <Route path="/brands" element={<Brands />} />
                  <Route path="/brands/:slug" element={<BrandPage />} />
                  <Route path="/trade-in" element={<TradeIn />} />
                  <Route path="/sell/start" element={<Protected><TradeInFlow /></Protected>} />
                  <Route path="/trade-in/start" element={<Protected><TradeInFlow /></Protected>} />
                  <Route path="/cloth-cash" element={<ClothCash />} />
                  <Route path="/account" element={<Protected><Account /></Protected>} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Protected><Checkout /></Protected>} />
                  <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
                  <Route path="/payment/cancel" element={<PaymentCancel />} />
                  <Route path="/auth" element={<Auth />} />
                  <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </main>
              <Footer />
            </div>
            <Toaster position="bottom-right" toastOptions={{ style: { background: "#111111", color: "#F9F8F6", border: "1px solid #333", borderRadius: 0 } }} />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </SmoothScroll>
  );
}

export default App;
